import React, { forwardRef, useRef } from "react";
import type { ReactNode } from "react";
import { useDropdownCloseListeners } from "@hooks/index";

type DropdownSimpleProps = {
  children?: ReactNode
  isOpen?: boolean
  className?: string
}

type DropdownProps = DropdownSimpleProps & {
  handleClose: () => void
}


const DROPDOWN_CLASSES = "z-10 bg-floral-white text-raisin-black top-0 left-0 shadow w-full absolute"

const Dropdown = ({ children, handleClose, isOpen, className = '' }: DropdownProps) => {
  const ref = useRef<HTMLDivElement>(null)
  useDropdownCloseListeners<HTMLDivElement>(ref, handleClose)

  return (<DropdownSimple className={className} isOpen={isOpen}>
    {children}
  </DropdownSimple >)
}

export const DropdownSimple = forwardRef<HTMLDivElement, DropdownSimpleProps>(({ children, isOpen = true, className = '' }, ref) => {
  const divClassName = [
    className || DROPDOWN_CLASSES,
    isOpen === false ? 'hidden' : ''
  ].join(' ')
  return (<div ref={ref} className={divClassName} >
    {children}
  </div >)
})

export default Dropdown;